import { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { toggleEventPreviewMode } from "../../../store/actions/admin/create-event";
import { useTypedSelector } from "../../../store/reducers/use-typed-selector";
import ModalComponent from "../modal/modal";
import Session from "../../live-event/session/session";
import classNames from 'classnames';
import '../../../scss/live-event/base/session/session.scss';
import './event-preview.scss';
import LiveEventDocumentHead from "../../live-event/live-event-document-head";
import { useParams } from "react-router";
import { ParamsProps } from "../../live-event/live-event";
import { EPreviewTypes } from "../../../types/working-model";
import PreviewEventChatMain from "../../live-event/event-chat/preview-event-chat-main";

interface SessionPreviewProps {
	open: boolean;
	singleSession?: boolean;
}

const SessionPreviewModal: React.FC<SessionPreviewProps> = ({ open, singleSession }) => {

	const workingSession = useTypedSelector(state => state.CreateSessionReducer.workingSession);
	const workingEvent = useTypedSelector(state => state.CreateEventReducer.workingEvent);
	const editorSize = useTypedSelector(state => state.CreateEventReducer.editorSize);
	const previewMode = useTypedSelector(state => state.CreateEventReducer.previewMode);

	const { language } = useParams() as ParamsProps;
	const dispatch = useDispatch();

	const closeModal = useCallback(() => {
		dispatch(toggleEventPreviewMode(null));
	}, [dispatch]);

	const previewSession = useMemo(() => {
		if (singleSession && workingEvent?.sessions[0]) {
			return workingEvent?.sessions[0];
		} else {
			return workingSession ?? undefined;
		}
	}, [singleSession, workingEvent, workingSession]);

	const template = workingEvent?.template?.name?.toLocaleLowerCase().replace(/\s/g, '') ?? '';

	const modalBody = useMemo(() => {
		return workingEvent && (workingSession || workingEvent.sessions[0]) && (
			<div className={classNames('session-preview-wrapper live-event-container', editorSize, template)}>
				<LiveEventDocumentHead eventBundle={workingEvent} />
				<Session previewBundle={workingEvent!} previewSession={previewSession} previewLanguage={language} />
				<PreviewEventChatMain isSessionPreview />
			</div>
		);
	}, [workingSession, workingEvent, editorSize, previewSession, language, template]);

	return (
		<div
			className="preview-modal"
			style={previewMode !== EPreviewTypes.Session ? { display: 'none' } : {}}
		>
			<ModalComponent
				open={open}
				onRequestClose={closeModal}
				cancellable={false}
				closeable={true}
				size={editorSize}
				eventPreview
			>
				{modalBody}
			</ModalComponent>
		</div>
	);
};

export default SessionPreviewModal;